/* ============================================================
   WowSticker — CATALOGO REALE (fonte: wowsticker.it)
   Unica fonte di verità per prodotti, prezzi, regole e contatti.
   Consumato da: guide.js (assistente), hero-chat.js, app.js (configuratore).
   Prezzi in EUR, IVA inclusa. Prezzo FISSO per lotto (materiale × dimensione × quantità).
   ============================================================ */
(function(){
  'use strict';

  var SIZES = ['3x3','5x3','5x5','7x5','7x7','10x7','10x10','12x5','12x12'];
  var QTYS  = [50,100,200,300,500,1000,2000];

  // area in cm² per ogni dimensione a listino
  function areaOf(sz){ var p = sz.split('x'); return (+p[0]) * (+p[1]); }

  // matrici prezzi: prodotto -> dimensione -> [50,100,200,300,500,1000,2000]
  var PRICES = {
    vinile: {
      '3x3':[19,23,29,35,40,59,90], '5x3':[22,25,31,37,45,75,105], '5x5':[25,28,35,47,49,90,140],
      '7x5':[28,39,45,44,89,140,210], '7x7':[36,43,68,80,120,180,270], '10x7':[39,49,84,105,140,210,290],
      '10x10':[45,45,98,126,167,280,390], '12x5':[35,50,72,99,135,220,350], '12x12':[69,110,149,190,216,330,420]
    },
    trasparente: {
      '3x3':[20,24,30,37,42,62,95], '5x3':[23,26,33,39,47,79,110], '5x5':[26,29,37,51,60,95,147],
      '7x5':[29,41,47,66,93,147,221], '7x7':[38,56,71,84,126,189,284], '10x7':[41,60,88,110,147,221,305],
      '10x10':[47,68,103,132,175,294,410], '12x5':[37,50,76,104,142,231,368], '12x12':[72,116,156,200,227,347,441]
    },
    olografico: {
      '3x3':[30,38,46,52,77,117,140], '5x3':[33,40,48,59,98,137,164], '5x5':[36,46,64,84,117,140,182],
      '7x5':[51,59,82,116,182,273,327], '7x7':[69,88,104,156,234,351,421], '10x7':[75,109,137,182,273,377,452],
      '10x10':[85,127,164,217,364,507,608], '12x5':[62,94,129,176,286,455,546], '12x12':[143,194,247,281,429,546,655]
    },
    prespaziato: {  // solo 7x7 in su
      '7x7':[47,69,88,104,156,234,351], '10x7':[51,75,109,137,182,273,377],
      '10x10':[59,85,127,164,217,364,507], '12x5':[46,62,94,129,176,286,455], '12x12':[90,143,194,247,281,429,546]
    },
    magnetico: {
      '3x3':[26,31,39,47,54,80,122], '5x3':[30,34,42,50,61,101,142], '5x5':[34,38,47,66,77,122,189],
      '7x5':[38,53,61,85,120,189,284], '7x7':[49,72,92,108,162,243,365], '10x7':[53,78,113,142,189,284,392],
      '10x10':[61,88,132,170,225,378,527], '12x5':[47,65,97,134,182,297,473], '12x12':[93,149,201,257,292,446,567]
    },
    dtf: {
      '3x3':[22,26,33,40,46,68,104], '5x3':[25,29,36,43,52,86,121], '5x5':[29,32,40,56,66,104,161],
      '7x5':[32,45,52,72,102,161,242], '7x7':[41,61,78,92,138,207,311], '10x7':[45,66,97,121,161,242,334],
      '10x10':[52,75,113,145,192,322,449], '12x5':[40,55,83,114,155,253,403], '12x12':[79,127,171,219,248,380,483]
    },
    oro: {
      '3x3':[23,28,35,42,48,71,108], '5x3':[26,30,37,44,54,90,126], '5x5':[30,34,42,59,68,108,168],
      '7x5':[34,47,54,76,107,168,252], '7x7':[43,64,82,96,144,216,324], '10x7':[47,69,101,126,168,252,348],
      '10x10':[54,78,118,151,200,336,468], '12x5':[42,58,86,119,162,264,420], '12x12':[83,132,179,228,259,396,504]
    }
  };

  // Stampa-Taglio (die-cut multicolore, INTAGLIATI): listino derivato dal vinile (+12%),
  // premium per stampa a colori pieni + taglio aderente al profilo lettera per lettera.
  PRICES.stampataglio = {};
  Object.keys(PRICES.vinile).forEach(function(sz){
    PRICES.stampataglio[sz] = PRICES.vinile[sz].map(function(v){ return Math.round(v*1.12); });
  });

  // Mezzo Taglio (kiss-cut): stesso listino del vinile classico (stesso materiale, taglio non passante).
  PRICES.mezzotaglio = {};
  Object.keys(PRICES.vinile).forEach(function(sz){ PRICES.mezzotaglio[sz] = PRICES.vinile[sz].slice(); });

  // Etichette: tecnicamente vinile classico lucido con destinazione packaging → stesso listino del vinile.
  PRICES.etichette = {};
  Object.keys(PRICES.vinile).forEach(function(sz){ PRICES.etichette[sz] = PRICES.vinile[sz].slice(); });

  // metadati prodotto (ordine = come mostrarli)
  var PRODUCTS = [
    { key:'vinile',      label:'Vinile Classico',   use:'Laptop · bottiglie · packaging · uso quotidiano', desc:'Vinile di alta qualità, colori vibranti e durata eccezionale. La scelta più versatile ed economica.', start:19 },
    { key:'trasparente', label:'Vinile Trasparente', use:'Vetri · prodotti · superfici lisce', desc:'Plastica trasparente che lascia visibile la superficie sotto. Media durabilità, si applica e rimuove facilmente.', start:20 },
    { key:'olografico',  label:'Olografici',         use:'Merch · brand · effetto premium', desc:'Effetto cangiante arcobaleno che riflette la luce. Il materiale premium dal massimo impatto “wow”.', start:30 },
    { key:'prespaziato', label:'Prespaziati',        use:'Vetrine · auto · insegne', desc:'Scritte e loghi intagliati a filo, con pellicola di trasferimento: stacca e posiziona. Solo da 7×7 cm in su.', start:46 },
    { key:'magnetico',   label:'Magnetici',          use:'Frigo · superfici metalliche · gadget', desc:'Magneti personalizzati per frigoriferi, lavagne e metallo. Colori vivaci, ideali per promozione.', start:26 },
    { key:'dtf',         label:'Termoadesivi (DTF)', use:'T-shirt · abbigliamento · tessuti', desc:'Sticker da applicare con il calore sui tessuti: perfetti per personalizzare capi e vestiti.', start:22 },
    { key:'oro',         label:'Oro',                use:'Inviti · confezioni regalo · lusso', desc:'Oro brillante che riflette la luce: un tocco di eleganza per inviti, packaging regalo e prodotti di lusso.', start:23 },
    { key:'stampataglio', label:'Stampa-Taglio',      use:'Loghi multicolore · scritte · forme libere', desc:'Die-cut professionale a colori pieni: la lama segue il profilo reale di ogni elemento, lettera per lettera, con i vuoti interni ritagliati. Il contraltare multicolore dei prespaziati.', start:21 },
    { key:'mezzotaglio', label:'Mezzo Taglio',        use:'Sticker da spellicolare · kit · omaggi', desc:'Kiss-cut: il vinile è inciso ma resta sul suo foglietto di supporto — stacchi solo lo sticker quando vuoi. Comodo e dall’aspetto professionale.', start:19 },
    { key:'etichette',   label:'Etichette',          use:'Barattoli · bottiglie · packaging', desc:'Etichette in vinile lucido resistente, perfette per barattoli, bottiglie e packaging. Impermeabili e di lunga durata.', start:19 },
    // ---- GRANDI FORMATI: venduti SOLO su misura, prezzo al m² (nessun formato a listino) ----
    { key:'maxi',        label:'Maxi Adesivi',       use:'Vetrine · muri · allestimenti', desc:'Adesivi di grande formato per vetrine, insegne e allestimenti. Massima visibilità con stampa ad alta risoluzione. Prezzo al m².', start:39, bigFormat:true, perM2:39 },
    { key:'parete',      label:'Da Parete',          use:'Casa · uffici · negozi', desc:'Wall sticker rimovibili che non lasciano residui: decora pareti e ambienti senza rovinare le superfici. Prezzo al m².', start:45, bigFormat:true, perM2:45 },
    { key:'calpestabile',label:'Calpestabili',       use:'Pavimenti · percorsi · eventi', desc:'Adesivi da pavimento resistenti e antiscivolo, con laminazione protettiva. Ideali per segnaletica ed eventi. Prezzo al m².', start:55, bigFormat:true, perM2:55 }
  ];

  // tariffa €/m² dei prodotti a grande formato (venduti solo su misura)
  function bigRate(key){
    for(var i=0;i<PRODUCTS.length;i++){ if(PRODUCTS[i].key===key) return PRODUCTS[i].bigFormat ? (PRODUCTS[i].perM2||0) : null; }
    return null;
  }

  var TIPO_LABEL = {};
  PRODUCTS.forEach(function(p){ TIPO_LABEL[p.key] = p.label; });

  var META = {
    minQty: 10,
    listinoMinQty: 50,
    shipping: 0,
    freeShippingOver: 0,
    previewCost: 5,
    newsletterDiscount: '10%',
    production: '24/48h lavorative',
    delivery: '24/72h',
    contacts: {
      whatsapp: '+39 388 909 5421',
      whatsappUrl: 'https://wa.me/393889095421',
      supporto: 'supporto@wowsticker.eu',
      info: 'info@wowsticker.eu',
      tel: '+393889095421'
    }
  };

  function sizesFor(key){ return Object.keys(PRICES[key] || {}); }

  // ============================================================
  // STICKER IN FOGLIO — prezzo per FOGLIO (unità di vendita), non per sticker.
  // Formati fissi: prezzo base per singolo foglio × moltiplicatore quantità.
  // Su misura: €/m² sulla superficie del foglio × moltiplicatore quantità.
  // Il numero di sticker nel foglio NON incide.
  // ============================================================
  var FOGLIO = {
    qtys: [10, 25, 50, 100, 250, 500, 1000],
    // formati carta in mm (ISO A)
    formats: {
      A6: { w:105, h:148, base:3.20 },
      A5: { w:148, h:210, base:5.20 },
      A4: { w:210, h:297, base:8.50 },
      A3: { w:297, h:420, base:15.00 }
    },
    // sconto per-foglio agli scaglioni di quantità (allineato a qtys)
    qtyMult: [1.00, 0.90, 0.80, 0.70, 0.58, 0.48, 0.40],
    perM2: 105,      // €/m² per il foglio su misura (prima dello sconto quantità)
    minSheet: 1.80   // prezzo minimo per foglio
  };
  function foglioMult(qty){
    var q = +qty, m = FOGLIO.qtyMult[0];
    for(var i=0;i<FOGLIO.qtys.length;i++){ if(q >= FOGLIO.qtys[i]) m = FOGLIO.qtyMult[i]; }
    return m;
  }
  // prezzo foglio: passa un formato fisso (A6..A3) OPPURE larghezza/altezza in mm per su misura.
  // Ritorna { perSheet, total, perM2? } o null.
  function priceFoglio(format, wMm, hMm, qty){
    var q = +qty; if(!(q > 0)) return null;
    var mult = foglioMult(q), per, perM2 = null;
    if(format && FOGLIO.formats[format]){
      per = FOGLIO.formats[format].base;
    } else {
      if(!(wMm > 0) || !(hMm > 0)) return null;
      var m2 = (wMm/1000) * (hMm/1000);         // superficie foglio in m²
      perM2 = FOGLIO.perM2;
      per = Math.max(perM2 * m2, FOGLIO.minSheet);
    }
    per = per * mult;
    var perSheet = Math.round(per * 100) / 100;
    return { perSheet: perSheet, total: Math.round(perSheet * q), perM2: perM2, mult: mult };
  }


  // ============================================================
  // REGOLE ADMIN (app Shopify "Prezzi Sticker") — fonte prioritaria.
  // Salvate in localStorage['wowPricingRules'] come { key: { basePerM2, tiers[],
  // formats[], recognize, rounding, minOrder } }. Quando esistono per un materiale,
  // sovrascrivono il listino derivato in questo file.
  // ============================================================
  var ADMIN_KEY = 'wowPricingRules';
  // Regole di default identiche ai "seeded defaults" dell'app Prezzi Sticker
  // (app/lib/pricing-defaults.ts): usate quando l'admin non ha ancora salvato
  // regole proprie, così il prezzo su misura del design coincide con lo store.
  var SEEDED = {
    vinile: { basePerM2:12, fixedOrderFee:20, minOrder:19, rounding:'0.10', recognize:true,
      tiers:[{from:0,to:1,price:42},{from:1,to:3,price:32},{from:3,to:5,price:25},{from:5,to:7,price:20},{from:7,to:10,price:20},{from:10,to:20,price:12}],
      formats:[
        {w:3,h:3,prices:[19,23,29,35,40,59,90]},
        {w:5,h:5,prices:[25,28,35,47,49,90,140]},
        {w:7,h:5,prices:[28,39,45,44,89,140,210]},
        {w:7,h:7,prices:[36,43,68,80,120,180,270]},
        {w:10,h:7,prices:[39,49,84,105,140,210,290]},
        {w:10,h:10,prices:[45,45,98,126,167,280,390]}
      ] },
    prespaziato: { basePerM2:16, fixedOrderFee:20, minOrder:19, rounding:'0.10', recognize:true,
      tiers:[{from:10,to:14.99,price:16},{from:15,to:20,price:14},{from:22,to:30,price:12}],
      formats:[
        {w:7,h:7,prices:[47,69,88,104,156,234,351]},
        {w:10,h:7,prices:[51,75,109,137,182,273,377]},
        {w:10,h:10,prices:[59,85,127,164,217,364,507]},
        {w:12,h:12,prices:[90,143,194,247,281,429,546]}
      ] },
    magnetico: { basePerM2:22, fixedOrderFee:20, minOrder:25, rounding:'0.10', recognize:true,
      tiers:[{from:10,to:20,price:20}],
      formats:[
        {w:5,h:5,prices:[34,38,47,66,77,122,189]},
        {w:7,h:5,prices:[38,53,61,85,120,189,284]},
        {w:10,h:7,prices:[53,78,113,142,189,284,392]}
      ] }
  };
  function getWindowPricingRules(){
    var all = window.WOW_PRICING_RULES;
    if(!all || typeof all !== 'object') return null;
    return all;
  }
  function getStoredPricingRules(){
    try{
      var all = JSON.parse(localStorage.getItem(ADMIN_KEY) || '{}');
      return all && typeof all === 'object' ? all : null;
    } catch(e){
      return null;
    }
  }
  function syncWindowRulesToStorage(){
    try{
      var winRules = getWindowPricingRules();
      if(!winRules) return;
      var stored = getStoredPricingRules() || {};
      var changed = false;
      for(var k in winRules){
        if(!Object.prototype.hasOwnProperty.call(winRules, k)) continue;
        var next = JSON.stringify(winRules[k] || null);
        var prev = JSON.stringify(stored[k] || null);
        if(next !== prev){
          stored[k] = winRules[k];
          changed = true;
        }
      }
      if(changed) localStorage.setItem(ADMIN_KEY, JSON.stringify(stored));
    } catch(e){}
  }
  function adminRules(key){
    var winRules = getWindowPricingRules();
    if(winRules && winRules[key]) return winRules[key];
    var stored = getStoredPricingRules();
    if(stored && stored[key]) return stored[key];
    return SEEDED[key] || null;
  }
  syncWindowRulesToStorage();
  function roundTotal(total, step){
    if(!step || step === 'none') return total;
    step = parseFloat(step); if(!(step > 0)) return total;
    return Math.ceil(total / step - 1e-9) * step;
  }
  function cents(n){ return Math.round(n * 100) / 100; }
  function matchFormat(rules, w, h){
    if(!rules || !rules.formats) return null;
    // stessa tolleranza dell'app (0.001) per evitare mismatch sui decimali
    function same(a,b){ return Math.abs(a-b) < 0.001; }
    for(var i = 0; i < rules.formats.length; i++){
      var f = rules.formats[i];
      if((same(f.w,w) && same(f.h,h)) || (same(f.w,h) && same(f.h,w))) return f;
    }
    return null;
  }
  // prezzo del lotto per un formato standard alla quantità richiesta.
  // Nuovo modello: prezzi per scaglione di quantità (f.prices allineato a QTYS).
  // Compat: se il formato ha ancora un prezzo fisso f.price → f.price × qty.
  function formatLot(f, qty){
    if(!f) return null;
    var qi = QTYS.indexOf(+qty);
    if(f.prices && qi >= 0 && f.prices[qi] != null) return f.prices[qi];
    if(typeof f.price === 'number') return f.price * (+qty);
    return null;
  }
  function formatLotAtOrBelow(f, qty){
    if(!f) return null;
    var qi = -1;
    for(var i=0;i<QTYS.length;i++){ if(QTYS[i] <= +qty) qi = i; }
    if(qi < 0) qi = 0;
    if(f.prices && f.prices[qi] != null) return { price:+f.prices[qi], priceQuantity:QTYS[qi] };
    if(typeof f.price === 'number') return { price:f.price*(+qty), priceQuantity:+qty };
    return null;
  }
  function tierRate(rules, areaTot){
    if(rules.tiers){
      for(var i = 0; i < rules.tiers.length; i++){
        var t = rules.tiers[i];
        if(areaTot >= t.from && areaTot <= t.to) return { rate: t.price, tier: t };
      }
    }
    return null;
  }
  function pushTierLine(lines, from, to, rate, isBaseRate){
    var mq = to-from;
    if(mq > 0) lines.push({ from:from, to:to, mq:mq, rate:+rate||0, amount:mq*(+rate||0), isBaseRate:!!isBaseRate });
  }
  function progressiveTierLines(rules, areaTot){
    if(!(areaTot > 0)) return [];
    var tiers = (rules.tiers || []).slice().sort(function(a,b){ return a.from-b.from; });
    var lines = [], cursor = 0, base = +rules.basePerM2 || 0;
    for(var i=0;i<tiers.length && cursor<areaTot;i++){
      var t=tiers[i], from=Math.max(0,+t.from||0), to=Math.max(from,+t.to||0);
      if(to<=cursor) continue;
      if(from>cursor){ var gapEnd=Math.min(from,areaTot); pushTierLine(lines,cursor,gapEnd,base,true); cursor=gapEnd; }
      if(cursor>=areaTot) break;
      var start=Math.max(cursor,from), end=Math.min(to,areaTot);
      if(end>start){ pushTierLine(lines,start,end,+t.price||0,false); cursor=end; }
    }
    if(cursor<areaTot) pushTierLine(lines,cursor,areaTot,base,true);
    return lines;
  }
  function formatFits(f,w,h){
    return (f.w<=w+0.001 && f.h<=h+0.001) || (f.h<=w+0.001 && f.w<=h+0.001);
  }
  function standardFloor(rules,w,h,qty){
    var best=null, formats=rules.formats||[];
    for(var i=0;i<formats.length;i++){
      var f=formats[i]; if(!formatFits(f,w,h)) continue;
      var lot=formatLotAtOrBelow(f,qty);
      if(lot && (!best || lot.price>best.price)) best={ format:f, requestedQuantity:+qty, priceQuantity:lot.priceQuantity, price:lot.price };
    }
    return best;
  }

  // prezzo esatto a listino (o null se combinazione non a listino)
  function priceFor(key, size, qty){
    // override admin: se il formato standard è a listino nell'app, usa prezzo fisso × qty
    var rules = adminRules(key);
    if(rules){
      var p = size.split('x'), w = +p[0], h = +p[1];
      var mf = matchFormat(rules, w, h);
      if(mf){
        var lot = formatLot(mf, qty);
        if(lot != null) return cents(roundTotal(Math.max(lot, rules.minOrder || 0), rules.rounding));
      }
    }
    var qi = QTYS.indexOf(+qty);
    if(qi < 0) return null;
    var row = PRICES[key] && PRICES[key][size];
    return row ? row[qi] : null;
  }

  // ---- CALCOLO ESATTO SU MISURA (prezzo al m²) ----
  // Tariffa €/cm² per pezzo, per (materiale × quantità), derivata dal listino:
  // mediana del prezzo-unitario/area sulle misure a listino → tariffa stabile e deterministica.
  // Nessuna stima "per dimensione vicina": il prezzo scala linearmente con l'area.
  function ratePerCm2(key, qty){
    var qi = QTYS.indexOf(+qty);
    if(qi < 0) return null;
    var rows = PRICES[key];
    if(!rows) return null;
    var vals = [];
    for(var s in rows){ if(rows.hasOwnProperty(s)) vals.push((rows[s][qi] / qty) / areaOf(s)); }
    if(!vals.length) return null;
    vals.sort(function(a,b){ return a-b; });
    var m = Math.floor(vals.length/2);
    return vals.length % 2 ? vals[m] : (vals[m-1] + vals[m]) / 2;   // €/cm² per pezzo
  }

  // Prezzo SU MISURA esatto.
  // Se esistono regole admin per il materiale → base €/mq + scaglioni sui mq totali
  // dell'ordine + riconoscimento formati standard + arrotondamento + ordine minimo.
  // Altrimenti → tariffa €/cm² derivata dal listino (lineare, deterministica).
  // Ritorna { unit, total, perCm2, perM2, tier?, matchedFormat? } o null.
  function priceCustom(key, wCm, hCm, qty){
    if(!(wCm > 0) || !(hCm > 0)) return null;
    var q = +qty; if(!(q > 0)) return null;

    var rules = adminRules(key);
    if(rules){
      // 1) riconoscimento formato standard (misura digitata = formato a listino)
      {
        var mf = matchFormat(rules, wCm, hCm);
        if(mf){
          var exactLot = formatLotAtOrBelow(mf, q);
          if(exactLot){
            var totF = cents(roundTotal(Math.max(exactLot.price, rules.minOrder || 0), rules.rounding));
            return { unit: totF / q, total: totF, perCm2: null, perM2: null, matchedFormat: mf, matchedFormatPrice:exactLot.price, exactStandardMatch:true, fixedOrderFee:0, tierLines:[], standardFloor:null, floorApplied:false };
          }
        }
      }
      // 2) quota fissa + scaglioni progressivi sui mq TOTALI dell'ordine
      var areaTot = (wCm * hCm) / 10000 * q;                 // m² totali
      var lines = progressiveTierLines(rules, areaTot);
      var variable = lines.reduce(function(sum,line){ return sum+line.amount; },0);
      var fixed = rules.fixedOrderFee == null ? 20 : Math.max(0,+rules.fixedOrderFee||0);
      var sub = fixed + variable;
      var floor = standardFloor(rules,wCm,hCm,q);
      var floorApplied = !!(floor && floor.price>sub && floor.price>=(rules.minOrder||0));
      var tot = cents(roundTotal(Math.max(sub, rules.minOrder || 0, floor ? floor.price : 0), rules.rounding));
      var lastRate = lines.length ? lines[lines.length-1].rate : (+rules.basePerM2||0);
      return { unit: tot / q, total: tot, subtotal:cents(sub), mqPerPiece:(wCm*hCm)/10000, totalMq:areaTot, fixedOrderFee:fixed, tierLines:lines, standardFloor:floor, floorApplied:floorApplied, perCm2:lastRate/10000, perM2:lastRate };
    }

    // grande formato: prodotti venduti SOLO al m² (nessun listino a formati fissi)
    var bf = bigRate(key);
    if(bf != null){
      var areaTotBf = (wCm * hCm) / 10000 * q;      // m² totali dell'ordine
      var totBf = cents(bf * areaTotBf);
      return { unit: totBf / q, total: totBf, perCm2: bf / 10000, perM2: bf };
    }

    // fallback: tariffa derivata dal listino
    var derived = ratePerCm2(key, qty);
    if(derived == null) return null;
    var unit = derived * (wCm * hCm);
    var total = Math.round(unit * q);
    return { unit: total / q, total: total, perCm2: derived, perM2: derived * 10000 };
  }

  // tariffa €/m² live per la nota "su misura" (base admin se presente, altrimenti derivata)
  function ratePerM2(key, qty){
    var rules = adminRules(key);
    if(rules) return rules.basePerM2 || 0;
    var bf = bigRate(key);
    if(bf != null) return bf;
    var r = ratePerCm2(key, qty);
    return r == null ? null : r * 10000;
  }

  // Compat: alias storico usato dall'assistente/guida — ora restituisce il TOTALE ESATTO.
  function estimateCustom(key, wCm, hCm, qty){
    var pc = priceCustom(key, wCm, hCm, qty);
    return pc == null ? null : pc.total;
  }

  window.WowCatalog = {
    SIZES: SIZES, QTYS: QTYS, PRICES: PRICES, PRODUCTS: PRODUCTS,
    TIPO_LABEL: TIPO_LABEL, META: META,
    sizesFor: sizesFor, priceFor: priceFor, estimateCustom: estimateCustom,
    priceCustom: priceCustom, ratePerCm2: ratePerCm2, ratePerM2: ratePerM2,
    adminRules: adminRules, areaOf: areaOf,
    FOGLIO: FOGLIO, priceFoglio: priceFoglio, foglioMult: foglioMult
  };
})();
